export default __webpack_public_path__ + "static/media/io.950da406.svg";